import React from 'react'
import styles from './index.module.css'

import {
  Grid,
  Typography,
  Button,
  Checkbox,
  makeStyles,
  CircularProgress
} from '@material-ui/core'
import cn from 'classname'
import Input from '../../input'
import { PRIVACY_VERSION, PRIVACY_NOTICE_URL, PRIVACY_APPLICATION_STATEMENT, PRIVACY_COMMUNICATIONS_STATEMENT } from '../privacy-settings'

export default ({ register, errors, isLoading, privacyConsent, onPrivacyChange, communicationsConsent, onCommunicationsChange, isComplete, missingFields}) => {
  const useStyles = makeStyles(() => ({
    rootCheckbox: {
      '&$checked': {
        color: '#1D9517',
      },
    },
    checked: {}
  }))

  const classes = useStyles()
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography component="h2" variant="h5" className={styles.sectionTitle}>Recapiti e privacy</Typography>
      </Grid>
      <Grid item xs={12}>
        <Input
          className={styles.input}
          name="phone"
          type="tel"
          autoComplete="tel"
          inputRef={register}
          placeholder="Inserisci il tuo telefono"
          fullWidth
          label="Telefono"
          helperText={errors?.phone?.message}
          error={!!errors?.phone?.message}
        />
      </Grid>
      <Grid item xs={12}>
        <Input
          className={styles.input}
          name="email"
          type="email"
          autoComplete="email"
          inputRef={register}
          placeholder="Inserisci la tua email"
          fullWidth
          label="Email"
          helperText={errors?.email?.message}
          error={!!errors?.email?.message}
        />
      </Grid>
      <Grid item xs={12}>
        <Input
          className={styles.input}
          name="password"
          autoComplete="new-password"
          isPassword
          inputRef={register}
          placeholder="Inserisci la tua password"
          fullWidth
          label="Password"
          helperText={errors?.password?.message}
          error={!!errors?.password?.message}
        />
      </Grid>
      <Grid item xs={12}>
        <div className={styles.privacyDocument}>
          <Typography component="h3" variant="h6">Informativa privacy</Typography>
          <Typography component="p" className={styles.privacyHelp}>Non è richiesta una firma sul PDF. Leggi l’informativa prima di scegliere e inviare la domanda.</Typography>
          <Button component="a" href={PRIVACY_NOTICE_URL} target="_blank" rel="noopener noreferrer" variant="outlined" className={styles.privacyLink}>Apri l’informativa privacy (PDF)</Button>
          <a href={PRIVACY_NOTICE_URL} download="Informativa_privacy_MRF.pdf" className={styles.downloadLink}>Scarica il PDF</a>
          <Typography component="p" className={styles.privacyHelp}>Versione: {PRIVACY_VERSION}</Typography>
        </div>
      </Grid>
      <Grid item xs={2} sm={1}>
        <Checkbox
          inputProps={{ id: 'privacy-consent', 'aria-label': 'Consenso al trattamento dei dati personali', 'aria-describedby': 'privacy-help' }}
          classes={{
            root: classes.rootCheckbox,
            checked: classes.checked
          }}
          checked={privacyConsent}
          onChange={event => onPrivacyChange(event.target.checked)}
        />
      </Grid>
      <Grid item xs={10} sm={11} >
        <Typography component="label" htmlFor="privacy-consent" variant={'body1'} className={styles.privacyTypography}>
          {PRIVACY_APPLICATION_STATEMENT}
        </Typography>
        <Typography id="privacy-help" className={styles.privacyHelp}>
          Puoi revocare il consenso in qualsiasi momento scrivendo a <a href="mailto:info@movimentorivoluzionefiscale.it?subject=Revoca%20consenso%20privacy">info@movimentorivoluzionefiscale.it</a>. La revoca non pregiudica la liceità del trattamento precedente; prima dell’esito può impedire di proseguire l’esame della domanda. Per i trattamenti necessari al rapporto associativo eventualmente instaurato valgono le basi giuridiche e i diritti indicati nell’informativa.
        </Typography>
      </Grid>
      <Grid item xs={12} >
        {!privacyConsent && <Typography className={styles.privacyTypography}>Per inviare la richiesta, conferma il consenso per esaminare la domanda di adesione.</Typography>}
      </Grid>
      <Grid item xs={2} sm={1}>
        <Checkbox
          inputProps={{ id: 'privacy-communications', 'aria-label': 'Consenso facoltativo agli aggiornamenti via email', 'aria-describedby': 'communications-help' }}
          classes={{ root: classes.rootCheckbox, checked: classes.checked }}
          checked={communicationsConsent}
          onChange={event => onCommunicationsChange(event.target.checked)}
        />
      </Grid>
      <Grid item xs={10} sm={11}>
        <Typography component="label" htmlFor="privacy-communications" className={styles.privacyTypography}>{PRIVACY_COMMUNICATIONS_STATEMENT}</Typography>
        <Typography id="communications-help" className={styles.privacyHelp}>Puoi lasciare questa casella vuota e inviare comunque la domanda. Puoi revocare questa scelta senza rinunciare all’adesione, scrivendo al medesimo indirizzo email.</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography component="p" id="completion-help" className={styles.completionHelp} aria-live="polite">
          {isComplete ? 'Dati completi: adesso puoi inviare la richiesta.' : `Per attivare l’invio, completa o correggi: ${missingFields.join(', ')}.`}
        </Typography>
      </Grid>
      <Grid item xs={12} container justify="center">
        <Button
          classes={{
            root: cn(isComplete ? styles.buttonGreen : styles.buttonRed, (!isComplete || isLoading) && styles.buttonDisabled),
          }}
          aria-label={isComplete ? "Adesso puoi Inviare" : "Completa e Invia"}
          aria-busy={isLoading}
          aria-describedby="completion-help"
          disabled={!isComplete || isLoading}
          variant="contained"
          type={'submit'}
        >
          {isLoading && <CircularProgress size={20} color="inherit" style={{ marginRight: 12 }} />}
          <span className={styles.buttonLabel}>{isComplete ? <>Adesso<br />puoi<br />Inviare</> : <>Completa<br />e<br />Invia</>}</span>
        </Button>
      </Grid>
    </Grid>
  )
}
